import { marked } from 'marked';
import { TOPICS } from '../data/topics.js';
import { PROJECTS } from '../data/projects.js';

// Allow raw HTML in markdown (needed for animated widgets)
marked.setOptions({ breaks: false });

// Two-tier flow:
//   1. Island click → small quick-panel (bottom-right) with topic + name + metric + "View case study" button
//   2. "View case study" → full-screen case-study overlay with rich markdown content

const caseStudies = import.meta.glob('../content/case-studies/*.md', { query: '?raw', import: 'default', eager: true });

function findCaseStudy(id) {
  return caseStudies[`../content/case-studies/${id}.md`] || null;
}

function generateStub(project) {
  return `# ${project.name}\n\n> ${project.metric}\n\nA deeper case study for this project is being written.${project.github ? ` In the meantime, the [source is on GitHub](${project.github}).` : ''}`;
}

let onCloseCallback = null;
let isQuickOpen = false;
let isFullOpen = false;
let currentId = null;

export function initPanel(closeCallback) {
  onCloseCallback = closeCallback;
  document.getElementById('cs-back').addEventListener('click', closeFull);
  document.getElementById('qp-close').addEventListener('click', closeQuick);
  document.getElementById('qp-view').addEventListener('click', openFull);
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (isFullOpen) closeFull();
      else if (isQuickOpen) closeQuick();
    }
  });
}

// Called when an island is focused — shows the small quick panel
export function openPanel(projectId) {
  const project = PROJECTS.find(p => p.id === projectId);
  if (!project) return;
  currentId = projectId;
  const topic = TOPICS[project.topic];

  const topicEl = document.getElementById('qp-topic');
  topicEl.textContent = topic.name;
  topicEl.style.color = topic.hex;
  document.getElementById('qp-title').textContent = project.name;
  document.getElementById('qp-metric').textContent = project.metric;
  document.getElementById('quick-panel').classList.add('open');
  isQuickOpen = true;
}

// Called when user clicks "View case study" on the quick panel
function openFull() {
  if (!currentId) return;
  const project = PROJECTS.find(p => p.id === currentId);
  if (!project) return;
  const topic = TOPICS[project.topic];

  const md = findCaseStudy(currentId) || generateStub(project);
  const html = marked.parse(md);
  document.getElementById('cs-body').innerHTML = `<div class="cs-content">${html}</div>`;

  const topicChip = document.getElementById('cs-topic');
  topicChip.textContent = topic.name;
  topicChip.style.color = topic.hex;
  topicChip.style.borderColor = topic.hex + '55';
  topicChip.style.background = topic.hex + '12';

  const ghEl = document.getElementById('cs-github');
  if (project.github) { ghEl.href = project.github; ghEl.style.display = ''; }
  else { ghEl.style.display = 'none'; }
  const demoEl = document.getElementById('cs-demo');
  if (project.demo) { demoEl.href = project.demo; demoEl.style.display = ''; }
  else { demoEl.style.display = 'none'; }

  document.getElementById('cs-body').scrollTop = 0;
  document.getElementById('case-study').classList.add('open');
  document.getElementById('quick-panel').classList.remove('open');
  isFullOpen = true;
  isQuickOpen = false;
}

function closeQuick() {
  document.getElementById('quick-panel').classList.remove('open');
  isQuickOpen = false;
  currentId = null;
  if (onCloseCallback) onCloseCallback();
}

function closeFull() {
  document.getElementById('case-study').classList.remove('open');
  isFullOpen = false;
  currentId = null;
  if (onCloseCallback) onCloseCallback();
}

export function isPanelOpen() {
  return isQuickOpen || isFullOpen;
}

export function isFullPanelOpen() {
  return isFullOpen;
}
